import { Button, Input } from 'antd';
import { Formik } from 'formik';
import React from 'react';

import FullPageLoader from '../../../foundation/components/full_page_loader/FullPageLoader';
import Modal from '../../../foundation/components/modal/Modal';
import { useVariantAccess } from '../hooks/useVariantAccess';
import { PubMedPublication } from '../redux';
import { pubmedFormValidationSchema } from '../validation_schemas/pubmed_validation_schema';
import { usePubMedModalLogic } from './hooks';

type PubMedModalType = {
  closeModal: () => void;
  onPubMedSuccess: (pubmedPublication: PubMedPublication) => void;
};

interface FormValues {
  pubmed_id?: string;
}

const PubMedModal = ({ closeModal, onPubMedSuccess }: PubMedModalType) => {
  const { canInteract } = useVariantAccess();

  // All logic extracted to custom hook for separation of concerns
  const { isLoading, modalOpts, initialValues, handleFormSubmit } =
    usePubMedModalLogic({ closeModal, onPubMedSuccess });

  return (
    <Modal {...modalOpts} className="h-proband-modal">
      {isLoading && <FullPageLoader />}
      <Formik
        initialValues={initialValues as FormValues}
        onSubmit={handleFormSubmit}
        validationSchema={pubmedFormValidationSchema}
      >
        {({
          errors,
          handleChange,
          values,
          handleSubmit,
          handleBlur,
          isValid,
          dirty,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className="c-form-field">
                <div className="c-form-field__label">PubMed ID:</div>
                <div className="c-form-field__wrapper">
                  <Input
                    name="pubmed_id"
                    onChange={handleChange}
                    type="text"
                    value={values.pubmed_id}
                    onBlur={handleBlur}
                    placeholder="Enter PubMed ID"
                    readOnly={!canInteract}
                  />
                  <div className="c-form-field__error">
                    {errors.pubmed_id ? errors.pubmed_id : undefined}
                  </div>
                </div>
              </div>

              <div className="c-form__btn-wrapper h-proband-modal__form-btn-wrapper">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="h-proband-modal__form-submit-btn"
                  disabled={!(isValid && dirty) || isLoading || !canInteract}
                >
                  Submit
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default PubMedModal;
